import { isDashboardCarouselScreen } from "../config/dashboardCarousel";

/** Home screen — system Back may exit the app. */
export const KPI_HOME_SCREEN = "kpi_dashboard";

/**
 * Top-level destination screens: hardware Back → KPI Dashboard.
 * Carousel dashboards (except KPI) are destinations via isTopLevelDestinationScreen.
 */
export const TOP_LEVEL_DESTINATION_SCREENS = new Set([
  "time_tracking_v2",
  "payroll_queue",
  "payroll_home",
  "crewpilot",
  "intelligence",
  "report_builder",
  "project_analytics",
  "payroll_report",
  "mission_control",
  "materials",
  "tasks",
  "planning",
  "estimate_hub",
  "invoice_hub",
  "administration",
  "user_management",
  "accounts_payable",
  "accounts_receivable",
  "estimate_pipeline",
  "open_session",
  "mode_select",
  "finance_dashboard",
  "play_store_readiness",
  "google_visibility",
]);

/**
 * App-router workflow screens: hardware Back uses the same action as each
 * screen's onBack prop (handled in App.js), not KPI Dashboard.
 */
export const APP_WORKFLOW_SCREENS = new Set([
  "start",
  "question",
  "review",
  "complete",
  "project_detail",
  "user_preferences",
  "settings",
  "finance_accounts",
  "finance_transactions",
  "finance_money_in",
  "finance_money_out",
  "finance_transfer",
]);

/** Auth / bootstrap screens — allow the browser default Back behavior. */
export const AUTH_FLOW_SCREENS = new Set([
  "onboarding",
  "email_confirmation",
  "update_password",
  "payroll_print_isolation",
]);

export function isTopLevelDestinationScreen(screen) {
  if (!screen || screen === KPI_HOME_SCREEN) {
    return false;
  }

  if (TOP_LEVEL_DESTINATION_SCREENS.has(screen)) {
    return true;
  }

  return isDashboardCarouselScreen(screen);
}

export function isAppWorkflowScreen(screen) {
  return APP_WORKFLOW_SCREENS.has(screen);
}

export function allowsSystemExitOnBack(screen) {
  return (
    screen === KPI_HOME_SCREEN ||
    AUTH_FLOW_SCREENS.has(screen)
  );
}
